module.exports = __webpack_public_path__ + "ef04481dda3c8a00ef4c5d83fac0bbf7.svg";